<template>
  <v-app-bar clipped-left elevate-on-scroll dense app :color="color" :dark="dark" class="mainbar">
    <template v-slot:img="{ props }">
      <v-img v-bind="props" gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.9)"></v-img>
    </template>
    <v-progress-linear
      background-color="pink lighten-3"
      color="pink lighten-1"
      indeterminate
      absolute
      top
      v-if="loading"
    ></v-progress-linear>
    <!--v-if="!$vuetify.breakpoint.mdAndUp"-->
    <v-app-bar-nav-icon  @click.stop="toggleDrawer()"></v-app-bar-nav-icon>
    
    <template v-if="!slide">
    <v-toolbar-title class="headline text-uppercase" @click="$router.push('/')" v-if="$vuetify.breakpoint.mdAndUp">
      <span class="amberd--text">live</span>
      <span class="font-weight-light">beam</span>
    </v-toolbar-title>
<div class="beta" v-if="$vuetify.breakpoint.mdAndUp">prototype</div>
    <v-toolbar-title class="caption text-uppercase subhead animated lightSpeedIn" @click="$router.push('/')" v-if="event">
      <span class="amberd--text">{{event.title.substring(0,3)}}</span>
      <span class="font-weight-light">{{event.title.substring(3,event.title.length)}}</span>
    </v-toolbar-title>
    
    </template>


<template v-if="slide">
  <v-toolbar-title class="headline text-uppercase animatedd fadeInDown slidetitle">
      {{ slide.title}}
    </v-toolbar-title>
  
</template>


    <v-spacer></v-spacer>

    <v-btn
        v-if="slide"
        text
        class="animated zoomIn delay-1  "
        color="amber"
        @click.stop="$router.push('/event/' + $route.params.eventid+ '/screens')"  
      >
        close
      </v-btn>

    

<template v-if="!slide">
    <v-btn icon @click="$auth.logout" v-if="user">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
    <v-btn icon @click="$router.push('/login')" v-if="!user">
      <v-icon>mdi-login</v-icon>
    </v-btn>
</template>
  </v-app-bar>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "MainAppBar",
  data: () => ({}),
  methods: {
    ...mapActions("application", ["toggleLoading", "setError", "toggleDrawer"])
  },
  computed: {
    ...mapState({
      user: state => state.application.user,
      loading: state => state.application.loading
    }),
    event() {
        const pageId = this.$route.params.eventid;
        if(!pageId)
          return null;

        return this.$store.state.events.data[pageId]
  },
     slide() {
      const slideid = this.$route.params.slideid;
      return this.$store.state.slides.data[slideid];
    }   ,
    color(){
      if(this.slide) {
        return "grey darken-3"
      }
      return null
    },
    dark() {
      return (this.slide ? true : false);
    }
  }
};
</script>

<style>
.beta {
  border-radius: 15px;
  background-color: red;
  font-size: 10px;
  margin-left: 10px;
  color: white;
  font-weight: bold;
  padding: 8px;
  text-transform: uppercase;
}
.mainbar {
    border-bottom: 1px solid rgba(0,0,0,0.1) !important;
    transition: background-color .3s ease-in-out !important; 
}

.subhead {
  margin-left:5px;
  border-left: 0px solid black;
  padding-left: 5px;
}

.slidetitle {
  padding-left: 0;
  border: 1px solid transparent;
}
.slidetitle:hover {
  border: 1px solid rgba(255, 192, 203, 0.733);
}
</style>
